import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ParticipantBooking } from 'app/library/course-offering-participants/models/participant-booking.model';
import { Module } from 'app/library/module/models/module.model';
import { RelevantExecution } from 'app/library/program-item/models/relevant-execution.model';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { IRemoveProgramParticipantsDialogResult } from './remove-program-participants-dialog-result.interface';

@Component({
    selector: 'app-remove-program-participants-dialog',
    templateUrl: './remove-program-participants-dialog.component.html',
    styleUrls: ['./remove-program-participants-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class RemoveProgramParticipantsDialogComponent extends UnsubscribeOnDestroy {
    @Input()
    title: string;

    @Input()
    program: Module;

    @Input()
    set participantBookings(value: ParticipantBooking[]) {
        this._participantBookings = value;
        this.isSingleParticipant = value?.length === 1;
        value?.forEach((participantBooking) => {
            participantBooking.relevantExecutions.forEach((execution) => {
                execution.isSelected = false;
            });
        });
    }

    get participantBookings(): ParticipantBooking[] {
        return this._participantBookings;
    }

    removeFromAllExecutions = false;
    areExecutionActionsDisabled = false;
    isSingleParticipant = false;

    private _participantBookings: ParticipantBooking[];

    constructor(public dialogRef: MatDialogRef<RemoveProgramParticipantsDialogComponent, IRemoveProgramParticipantsDialogResult | false>) {
        super();
    }

    onBookingToggleChange(relevantExecution: RelevantExecution, value: string): void {
        if (this.areExecutionActionsDisabled) {
            return;
        }

        relevantExecution.isSelected = value === 'unbook';
    }

    onRemoveFromAllChange(checked: boolean): void {
        this.removeFromAllExecutions = checked;
        this.areExecutionActionsDisabled = checked;

        this._participantBookings?.forEach((participantBooking) => {
            participantBooking.relevantExecutions.forEach((execution) => {
                execution.isSelected = checked;
            });
        });
    }

    confirm(): void {
        const bookings: { user_id: string; execution_id: string }[] = [];

        this._participantBookings?.forEach((participantBooking) => {
            participantBooking.relevantExecutions.forEach((execution) => {
                if (execution.isSelected) {
                    bookings.push({
                        user_id: participantBooking.user.id,
                        execution_id: execution.id,
                    });
                }
            });
        });

        const totalExecutions = this._participantBookings?.reduce((count, booking) => count + booking.relevantExecutions.length, 0) || 0;

        const result: IRemoveProgramParticipantsDialogResult = {
            bookings,
            removeFromProgram: this.removeFromAllExecutions || (totalExecutions > 0 && bookings.length === totalExecutions),
        };

        this.dialogRef.close(result);
    }
}
